<template>
  <div>
    <hi-card v-for="(item, index) in conclusionInfoList" :key="index" :row-index="index + 1">
      <van-row>
        <span>审厂人：</span>
        <span>{{ item.engineerUserName }}</span>
      </van-row>
      <van-row>
        <span>审核人所在部门：</span>
        <span>{{ item.reviewDept }}</span>
      </van-row>
      <van-row>
        <span>审厂评价得分：</span>
        <span>{{ item.checkResultScore }}</span>
      </van-row>
      <van-row>
        <span>最终结果：</span>
        <span>{{ item.catgId | dictFilter(catgIdOptions) }}</span>
      </van-row>
      <van-row>
        <span>合格是否整改：</span>
        <span>{{ item.isRectify | dictFilter(isRectifyOptions) }}</span>
      </van-row>
      <van-row>
        <span>意见：</span>
        <span>{{ item.checkComment }}</span>
      </van-row>
      <van-row>
        <span>维护时间：</span>
        <span>{{ item.updTime }}</span>
      </van-row>
    </hi-card>
  </div>
</template>

<script>
export default {
  name: 'ConclusionInfo',
  components: {},
  data() {
    return {}
  },
  props: {
    conclusionInfoList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    catgIdOptions() {
      return this.$store.getters.dicts.yes_no
    },
    isRectifyOptions() {
      return this.$store.getters.dicts.yes_no
    }
  }
}
</script>
